import React from 'react';
import PropTypes from "prop-types";
import {formatDate} from "../includes/utils";

export function CsfPivotalFournisseurRecognitionDetailsTab1({formDetail, contact}) {

  const langcode = document.documentElement.lang;

  function handlePrint() {
    document.querySelector('.print-recognition').classList.add('show');
    document.querySelector('.print-confirmation').classList.remove('show');
    window.print();
  }

  return (
    <div className="tab-panel" id="ask-tab" role="tabpanel">
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.res_person')}
        </div>
        <div className="tab-line-value">
          {contact.First_Name} {contact.Last_Name}
          <span>{contact.Email}</span>
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.chk_one_time')}
        </div>
        <div className="tab-line-value">
          {formDetail.Recognition_Offered_Once ? (
            window.Drupal.t('Yes')
          ) : (
            window.Drupal.t('No')
          )}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.date_start_recog')}
        </div>
        <div className="tab-line-value">
          {formDetail.Cycle__Secondary && formDetail.Cycle__Secondary.length > 0 && (
            formDetail.Cycle__Secondary[formDetail.Cycle__Secondary.length - 1].Start_Date && (
                formatDate(formDetail.Cycle__Secondary[formDetail.Cycle__Secondary.length - 1].Start_Date)
            )
          )}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.date_end_recog')}
        </div>
        <div className="tab-line-value">
          {formDetail.Cycle__Secondary && formDetail.Cycle__Secondary.length > 0 && (
            formDetail.Cycle__Secondary[formDetail.Cycle__Secondary.length - 1].End_Date && (
              formatDate(formDetail.Cycle__Secondary[formDetail.Cycle__Secondary.length - 1].End_Date)
            )
          )}
        </div>
      </div>
      <div className="tab-line-item ">
        <div className="d-flex align-items-center tab-line-flex">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.recognition.detail.chk_submit_iqpf')}
          </div>
          <div className="tab-line-value">
            {formDetail.Submitted_To_Financial_Instit === true ? (
              window.Drupal.t('Yes')
            ) : (
              window.Drupal.t('No')
            )}
          </div>
        </div>


        { (formDetail.Status_Activity_Id === "AAAAAAAAABE=" && formDetail.Submitted_To_Financial_Instit === true) && (
          <div className="prereq-content" >{window.Drupal.t('fournisseur.recognition.detail.details.note.final')}</div>
        )}


      </div>
      {formDetail.Submitted_To_Financial_Instit === true && (
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.recognition.detail.chk_shown_website')}
        </div>
        <div className="tab-line-value">
          {formDetail.Showed_On_WebSite ? (
            window.Drupal.t('Yes')
          ) : (
            window.Drupal.t('No')
          )}
        </div>
      </div>
      )}
      {formDetail.Submitted_To_Financial_Instit === true && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('Region')}
          </div>
          <div className="tab-line-value">
            {
              formDetail.Region__Secondary && formDetail.Region__Secondary.length > 0 &&
              (
                formDetail.Region__Secondary.map((region) => {
                  return (
                    <p key={region.TM_Territory_Id__Rn_Descriptor}>
                      { langcode === 'en' && region.En_territory_Name ? region.En_territory_Name : region.TM_Territory_Id__Rn_Descriptor}
                    </p>
                  );
                })
              )
            }
          </div>
        </div>
      )}
    </div>
  );
}

CsfPivotalFournisseurRecognitionDetailsTab1.propTypes = {
  formDetail: PropTypes.object,
  contact: PropTypes.object
};
